import { render, staticRenderFns } from "./coursePrice.vue?vue&type=template&id=06fe3316&scoped=true&"
import script from "./coursePrice.vue?vue&type=script&lang=js&"
export * from "./coursePrice.vue?vue&type=script&lang=js&"
import style0 from "./coursePrice.vue?vue&type=style&index=0&id=06fe3316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe3316",
  null
  
)

export default component.exports